export class ProductDetailContent extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.trackFrame = this.trackFrame.bind(this)
    this.syncFrozenPosition = this.syncFrozenPosition.bind(this)

    this.rafId = window.requestAnimationFrame(this.trackFrame)

    this.bodyObserver = new MutationObserver(this.syncFrozenPosition)
    this.bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.bodyObserver) this.bodyObserver.disconnect()
    if (this.rafId) window.cancelAnimationFrame(this.rafId)
  }

  trackFrame () {
    if (getComputedStyle(this).position === 'sticky') {
      this.lastStuckTop = this.getBoundingClientRect().top
    }

    this.rafId = window.requestAnimationFrame(this.trackFrame)
  }

  syncFrozenPosition () {
    if (getComputedStyle(this).position === 'sticky') {
      this.style.transform = ''
      return
    }

    if (this.lastStuckTop === undefined) return

    const delta = this.lastStuckTop - this.getBoundingClientRect().top
    this.style.transform = Math.abs(delta) > 0.5 ? `translateY(${delta}px)` : ''
  }
}

if (!customElements.get('product-detail-content')) {
  customElements.define('product-detail-content', ProductDetailContent)
}
